import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_THUCHIHOPDONG } from "actions/ThuChiHopDong/actionTypes";
import {
  getListThuChiHopDongSuccess,
  getListThuChiHopDongFailure,
} from "actions/ThuChiHopDong";
import ThuChiHopDongApi from "service/thuChiHopDongApi";
import { pushNotification } from "utils/notifications";

function* getListThuChiHopDong(action) {
  try {
    const response = yield call(ThuChiHopDongApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListThuChiHopDongSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListThuChiHopDongFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListThuChiHopDongFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_THUCHIHOPDONG, getListThuChiHopDong);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
